import React from 'react'
// @ts-ignore
import Scrollchor from 'react-scrollchor'

const LOCALES = {
  title: {
    de: 'Zahlen Sie nächstes Jahr mehr Steuern in Ihrer Gemeinde?',
    fr: ''
  },
  lead: {
    de: (
      <>
        Vor kurzem hat der Kanton die Steueranlagen der Berner Gemeinden für das Jahr 2022 veröffentlicht. Es ändert einiges. Auch in Ihrer Gemeinde?
      </>
    ),
    fr: (
      <>
        Une analyse des impôts fédéraux montre l'écart entre les revenus et l'étendue des inégalités dans la commune – et indique si la situation a évolué au cours des dernières années.
      </>
    )
  },
  feedback: {
    title: {
      de: 'Wie wars?',
      fr: 'Comment jugez-vous ce contenu?'
    },
    questions: {
      de: [
        'Funktionierte die technische Umsetzung?',
        'Wie beurteilen Sie die Textqualität?',
        'Wie beurteilen Sie den Nutzen dieses Textes?'
      ],
      fr: [
        'La mise en oeuvre technique a-t-elle fonctionné?',
        'Comment évaluez-vous la qualité du texte?',
        'Comment évaluez-vous l’utilité du texte?'
      ]
    }
  },
  methodology: {
    title: {
      de: <>Wie dieser Text geschrieben wurde</>,
      fr: <>Comment ce texte est-il écrit?</>
    },
    text: {
      de: (
        <>
          <p>
          Dieser Text basiert auf Daten, die für jede Gemeinde aufbereitet wurden. Die Redaktorinnen und Redaktoren von Tamedia haben einen regelbasierten Algorithmus entworfen, der gemäss den Daten für jede Gemeinde einen individuellen Text schreibt. 
          </p>
          <p>Die Daten stammen <a href="https://www.sv.fin.be.ch/de/start/themen/steuern-berechnen/steueranlagen.html">aus den Steueranlagen 2022</a> des Kantons Bern. Anmerkung: Die Anlagen der Gemeinden Niederbipp und Köniz sind noch provisorisch.</p>
        </>
      ),
      fr: (
        <>
          <p>
          </p>
          <p></p>
        </>
      )
    }
  },
  credits: {
    de: [
      [
        'Umsetzung',
         'Timo Grossenbacher und Pavle Djuric'
      ],
      ['Projektleitung', 'Timo Grossenbacher']
    ],
    fr: [
      ['Réalisation', 'Timo Grossenbacher et Pavle Djuric'],
      ['Gestion du projet', 'Timo Grossenbacher']
    ]
  },
  municipalitySearchBoxTitle: {
    de: 'Eine andere Gemeinde anzeigen',
    fr: 'Cherchez une autre commune'
  }
}

export default LOCALES
